// inventory.reducer.js
import { inventoryConstants } from '../actions/constants';

const initialState = {
    warehouses: [],
    stock: [],
    batches: [],
    materials: [],
    movements: [],

    bomProducts: [],
    bomProductsSource: 'office',
    bomProductsSearchBy: 'all',
    bomProductsSortBy: 'newest',
    bomProductsPage: 1,
    bomProductsLimit: 24,
    bomProductsTotal: 0,
    bomProductsPages: 1,
    bomProductsHasNext: false,
    bomProductsHasPrev: false,
    bomProductsCategorySlugs: [],

    bomProductPicturesById: {},
    bomProductPicturesLoadingById: {},
    bomProductPicturesErrorById: {},

    bomByProduct: {},
    reservationsByOrder: {},

    loading: false,
    materialsLoading: false,
    materialSaving: false,
    movementsLoading: false,
    bomProductsLoading: false,

    error: null,
    materialError: null,
    movementError: null,
    bomProductsError: null,

    message: null,
};

export default function inventoryReducer(state = initialState, action) {
    switch (action.type) {
        case inventoryConstants.GET_WAREHOUSES_REQUEST:
        case inventoryConstants.CREATE_WAREHOUSE_REQUEST:
        case inventoryConstants.UPDATE_WAREHOUSE_REQUEST:
        case inventoryConstants.TOGGLE_WAREHOUSE_REQUEST:
        case inventoryConstants.GET_STOCK_SUMMARY_REQUEST:
        case inventoryConstants.LIST_BATCHES_REQUEST:
        case inventoryConstants.RECEIVE_STOCK_REQUEST:
        case inventoryConstants.ADJUST_STOCK_REQUEST:
        case inventoryConstants.TRANSFER_STOCK_REQUEST:
        case inventoryConstants.CLEANUP_STOCK_REQUEST:
        case inventoryConstants.UPSERT_BOM_REQUEST:
        case inventoryConstants.GET_BOM_REQUEST:
        case inventoryConstants.DELETE_BOM_REQUEST:
        case inventoryConstants.RESERVE_REQUEST:
        case inventoryConstants.CONSUME_RESERVATION_REQUEST:
        case inventoryConstants.CANCEL_RESERVATION_REQUEST:
        case inventoryConstants.GET_RESERVATIONS_BY_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };

        case inventoryConstants.GET_MATERIALS_REQUEST:
            return {
                ...state,
                materialsLoading: true,
                materialError: null,
            };

        case inventoryConstants.CREATE_MATERIAL_REQUEST:
        case inventoryConstants.UPDATE_MATERIAL_REQUEST:
        case inventoryConstants.ARCHIVE_MATERIAL_REQUEST:
            return {
                ...state,
                materialSaving: true,
                materialError: null,
            };

        case inventoryConstants.GET_STOCK_MOVEMENTS_REQUEST:
            return {
                ...state,
                movementsLoading: true,
                movementError: null,
            };

        case inventoryConstants.GET_BOM_PRODUCTS_REQUEST:
            return {
                ...state,
                bomProductsLoading: true,
                bomProductsError: null,
            };

        case inventoryConstants.GET_BOM_PRODUCT_PICTURES_REQUEST:
            return {
                ...state,
                bomProductPicturesLoadingById: {
                    ...state.bomProductPicturesLoadingById,
                    [action.payload.productId]: true,
                },
                bomProductPicturesErrorById: {
                    ...state.bomProductPicturesErrorById,
                    [action.payload.productId]: null,
                },
            };

        case inventoryConstants.GET_WAREHOUSES_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouses: action.payload.warehouses || [],
            };

        case inventoryConstants.CREATE_WAREHOUSE_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouses: action.payload.warehouse
                    ? [action.payload.warehouse, ...state.warehouses]
                    : state.warehouses,
                message: 'Склад создан',
            };

        case inventoryConstants.UPDATE_WAREHOUSE_SUCCESS:
        case inventoryConstants.TOGGLE_WAREHOUSE_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouses: state.warehouses.map((warehouse) => (
                    warehouse._id === action.payload.warehouse._id
                        ? action.payload.warehouse
                        : warehouse
                )),
            };

        case inventoryConstants.GET_STOCK_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                stock: action.payload.stock || [],
            };

        case inventoryConstants.LIST_BATCHES_SUCCESS:
            return {
                ...state,
                loading: false,
                batches: action.payload.batches || [],
            };

        case inventoryConstants.RECEIVE_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Приход добавлен',
            };

        case inventoryConstants.ADJUST_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Корректировка выполнена',
            };

        case inventoryConstants.TRANSFER_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Трансфер выполнен',
            };

        case inventoryConstants.CLEANUP_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Очистка выполнена',
            };

        case inventoryConstants.UPSERT_BOM_SUCCESS:
            return {
                ...state,
                loading: false,
                bomByProduct: action.payload.bom
                    ? {
                        ...state.bomByProduct,
                        [action.payload.bom.productId]: action.payload.bom,
                    }
                    : state.bomByProduct,
                message: 'BOM сохранён',
            };

        case inventoryConstants.GET_BOM_SUCCESS:
            return {
                ...state,
                loading: false,
                bomByProduct: {
                    ...state.bomByProduct,
                    [action.payload.productId]: action.payload.bom,
                },
            };

        case inventoryConstants.DELETE_BOM_SUCCESS:
            {
                const next = { ...state.bomByProduct };
                delete next[action.payload.productId];

                return {
                    ...state,
                    loading: false,
                    bomByProduct: next,
                    message: 'BOM удалён',
                };
            }

        case inventoryConstants.RESERVE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Резерв создан',
            };

        case inventoryConstants.CONSUME_RESERVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Списано',
            };

        case inventoryConstants.CANCEL_RESERVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Резерв отменён',
            };

        case inventoryConstants.GET_RESERVATIONS_BY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                reservationsByOrder: {
                    ...state.reservationsByOrder,
                    [action.payload.orderId]: action.payload.reservations,
                },
            };

        case inventoryConstants.GET_MATERIALS_SUCCESS:
            return {
                ...state,
                materialsLoading: false,
                materials: action.payload.materials || [],
            };

        case inventoryConstants.CREATE_MATERIAL_SUCCESS:
            return {
                ...state,
                materialSaving: false,
                materials: action.payload.material
                    ? [
                        action.payload.material,
                        ...state.materials.filter((material) => (
                            material._id !== action.payload.material._id
                        )),
                    ]
                    : state.materials,
                message: 'Материал создан',
            };

        case inventoryConstants.UPDATE_MATERIAL_SUCCESS:
            return {
                ...state,
                materialSaving: false,
                materials: action.payload.material
                    ? state.materials.map((material) => (
                        material._id === action.payload.material._id
                            ? action.payload.material
                            : material
                    ))
                    : state.materials,
                message: 'Материал обновлён',
            };

        case inventoryConstants.ARCHIVE_MATERIAL_SUCCESS:
            return {
                ...state,
                materialSaving: false,
                materials: state.materials.filter((material) => (
                    material._id !== action.payload.materialId
                )),
                message: 'Материал архивирован',
            };

        case inventoryConstants.GET_STOCK_MOVEMENTS_SUCCESS:
            return {
                ...state,
                movementsLoading: false,
                movements: action.payload.movements || [],
            };

        case inventoryConstants.GET_BOM_PRODUCTS_SUCCESS:
            return {
                ...state,
                bomProductsLoading: false,
                bomProducts: action.payload.products || [],
                bomProductsSource: action.payload.source || 'office',
                bomProductsSearchBy: action.payload.searchBy || 'all',
                bomProductsSortBy: action.payload.sortBy || 'newest',
                bomProductsPage: action.payload.page || 1,
                bomProductsLimit: action.payload.limit || 24,
                bomProductsTotal: action.payload.total || 0,
                bomProductsPages: action.payload.pages || 1,
                bomProductsHasNext: action.payload.hasNext === true,
                bomProductsHasPrev: action.payload.hasPrev === true,
                bomProductsCategorySlugs: action.payload.categorySlugs || [],
            };

        case inventoryConstants.GET_BOM_PRODUCT_PICTURES_SUCCESS:
            return {
                ...state,
                bomProductPicturesById: {
                    ...state.bomProductPicturesById,
                    [`${action.payload.productId}:${action.payload.imageQuality || 'low'}`]: action.payload.items || [],
                },
                bomProductPicturesLoadingById: {
                    ...state.bomProductPicturesLoadingById,
                    [action.payload.productId]: false,
                },
            };

        case inventoryConstants.GET_MATERIALS_FAILURE:
            return {
                ...state,
                materialsLoading: false,
                materialError: action.payload.error || 'Ошибка',
            };

        case inventoryConstants.CREATE_MATERIAL_FAILURE:
        case inventoryConstants.UPDATE_MATERIAL_FAILURE:
        case inventoryConstants.ARCHIVE_MATERIAL_FAILURE:
            return {
                ...state,
                materialSaving: false,
                materialError: action.payload.error || 'Ошибка',
            };

        case inventoryConstants.GET_STOCK_MOVEMENTS_FAILURE:
            return {
                ...state,
                movementsLoading: false,
                movementError: action.payload.error || 'Ошибка',
            };

        case inventoryConstants.GET_BOM_PRODUCTS_FAILURE:
            return {
                ...state,
                bomProductsLoading: false,
                bomProductsError: action.payload.error || 'Ошибка',
            };

        case inventoryConstants.GET_BOM_PRODUCT_PICTURES_FAILURE:
            return {
                ...state,
                bomProductPicturesLoadingById: {
                    ...state.bomProductPicturesLoadingById,
                    [action.payload.productId]: false,
                },
                bomProductPicturesErrorById: {
                    ...state.bomProductPicturesErrorById,
                    [action.payload.productId]: action.payload.error || 'Ошибка',
                },
            };

        case inventoryConstants.GET_WAREHOUSES_FAILURE:
        case inventoryConstants.CREATE_WAREHOUSE_FAILURE:
        case inventoryConstants.UPDATE_WAREHOUSE_FAILURE:
        case inventoryConstants.TOGGLE_WAREHOUSE_FAILURE:
        case inventoryConstants.GET_STOCK_SUMMARY_FAILURE:
        case inventoryConstants.LIST_BATCHES_FAILURE:
        case inventoryConstants.RECEIVE_STOCK_FAILURE:
        case inventoryConstants.ADJUST_STOCK_FAILURE:
        case inventoryConstants.TRANSFER_STOCK_FAILURE:
        case inventoryConstants.CLEANUP_STOCK_FAILURE:
        case inventoryConstants.UPSERT_BOM_FAILURE:
        case inventoryConstants.GET_BOM_FAILURE:
        case inventoryConstants.DELETE_BOM_FAILURE:
        case inventoryConstants.RESERVE_FAILURE:
        case inventoryConstants.CONSUME_RESERVATION_FAILURE:
        case inventoryConstants.CANCEL_RESERVATION_FAILURE:
        case inventoryConstants.GET_RESERVATIONS_BY_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error || 'Ошибка',
            };

        default:
            return state;
    }
}